import { render, staticRenderFns } from "./OrderRouteDeleteConfirm.vue?vue&type=template&id=8333258c&"
import script from "./OrderRouteDeleteConfirm.vue?vue&type=script&lang=js&"
export * from "./OrderRouteDeleteConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports